/* ===========================================================================
   VJ-CORR-D343 — DEUX MARQUES COCHÉES : L'UNE OU L'AUTRE
   14 septembre 2026
   ---------------------------------------------------------------------------
   Le chemin de tag de Shopify fait un ET : /collections/all/cartier+celine ne
   rend aucune pièce. Quand la grille porte un hôte `[data-vj-union]` (posé par
   sections/main-collection-product-grid.liquid dès que PLUS D'UNE marque est
   cochée), on relit la même collection avec les AUTRES tags seulement, page par
   page, par la Section Rendering API, et on garde les cartes dont la marque
   (`data-vj-marque`) est cochée.

   - l'ordre est celui que Shopify rend pour le tri demandé (on recopie tous les
     paramètres de l'adresse : sort_by, filter.v.*…) ;
   - une carte n'entre qu'une fois (clé : l'adresse de la fiche) ;
   - vingt pages au plus (douze pièces par page : 240 pièces), garde-fou ;
   - wdt-filter.js remplace la grille en AJAX au tri et aux facettes : un
     MutationObserver repasse sur tout hôte neuf.

   Rollback : voir VJ-CORR-D343 dans la section.

   VJ-CORR-D588 — 5 octobre 2026 — LES DISPONIBLES D'ABORD, ICI AUSSI.
   On lit d'abord la liste des pièces disponibles (`filter.v.availability=1`),
   page par page, puis celle des épuisées (`=0`) : les cartes gardées arrivent
   dans cet ordre. Le nombre de pages d'une liste est écrit par la section sur
   la grille (`data-vj-liste-pages`). Si la boutique n'a plus la facette, les
   deux passages rendent la même liste : le dédoublonnage la garde une fois, et
   un dernier rangement (épuisées en dernier, ordre conservé) tient la règle.
   Rollback : VINTEJI-CONTROLES/r43/vj-union-marques.js.avant-d588.
   D590 : si la cliente a CHOISI une disponibilité dans Filtrer (la facette sans la
   marque `vj=suite` de la pagination), on ne lit que cette liste-là.
   =========================================================================== */
(function () {
  'use strict';

  var PAGES_MAX = 20;
  var LISTES = ['1', '0'];

  function adresse(hote, page, liste) {
    var chemin = hote.getAttribute('data-vj-base') || '/collections/all';
    var autres = hote.getAttribute('data-vj-autres') || '';
    var u = new URL(chemin + (autres ? '/' + autres : ''), window.location.origin);
    new URLSearchParams(window.location.search).forEach(function (v, k) {
      if (k !== 'page' && k !== 'section_id' && k !== 'filter.v.availability' && k !== 'vj') u.searchParams.append(k, v);
    });
    u.searchParams.set('filter.v.availability', liste);
    u.searchParams.set('section_id', hote.getAttribute('data-vj-section'));
    u.searchParams.set('page', String(page));
    return u.toString();
  }

  function pluriel(n) {
    return n > 1 ? n + ' pièces authentifiées' : n + ' pièce authentifiée';
  }

  function remplir(hote) {
    if (hote.getAttribute('data-vj-fait') === '1') return;
    hote.setAttribute('data-vj-fait', '1');

    var grille = hote.querySelector('[data-vj-union-grille]');
    var etat = hote.querySelector('[data-vj-union-etat]');
    var voulues = (hote.getAttribute('data-vj-marques') || '').split(',').filter(Boolean);
    if (!grille || voulues.length < 2) return;

    var vues = {};
    var gardees = [];
    var ici = new URLSearchParams(window.location.search);
    var choisies = ici.getAll('filter.v.availability');
    var listes = (choisies.length === 1 && ici.get('vj') !== 'suite') ? choisies : LISTES;

    function finir() {
      var frag = document.createDocumentFragment();
      var dispo = gardees.filter(function (li) { return !li.querySelector('.vj-carte--epuisee'); });
      var epuisees = gardees.filter(function (li) { return !!li.querySelector('.vj-carte--epuisee'); });
      gardees = dispo.concat(epuisees);
      gardees.forEach(function (li) { frag.appendChild(document.importNode(li, true)); });
      grille.appendChild(frag);
      var n = gardees.length;
      if (etat) {
        if (n === 0) {
          etat.textContent = 'Aucune pièce de ces maisons pour le moment.';
        } else {
          etat.hidden = true;
        }
      }
      document.querySelectorAll('[data-vj-union-compte]').forEach(function (el) {
        el.textContent = pluriel(n);
      });
      document.querySelectorAll('.btn-filters-view-results').forEach(function (b) {
        b.textContent = 'Voir ' + (n > 1 ? n + ' produits' : n + ' produit');
      });
      window.dispatchEvent(new Event('vj:grille-remplacee'));
    }

    function lire(liste, page) {
      if (liste >= listes.length) { finir(); return; }
      if (page > PAGES_MAX) { lire(liste + 1, 1); return; }
      fetch(adresse(hote, page, listes[liste]), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) { lire(liste + 1, 1); return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cartes = doc.querySelectorAll('li.product-loop[data-vj-marque]');
          if (!cartes.length) { lire(liste + 1, 1); return; }
          Array.prototype.forEach.call(cartes, function (li) {
            if (voulues.indexOf(li.getAttribute('data-vj-marque')) < 0) return;
            var lien = li.querySelector('a[href*="/products/"]');
            var cle = lien ? lien.getAttribute('href').split('?')[0] : li.textContent.trim().slice(0, 80);
            if (vues[cle]) return;
            vues[cle] = true;
            gardees.push(li);
          });
          var grilleLue = doc.querySelector('[data-vj-liste-pages]');
          var pages = grilleLue ? parseInt(grilleLue.getAttribute('data-vj-liste-pages'), 10) || 1 : 1;
          if (page < pages) lire(liste, page + 1);
          else lire(liste + 1, 1);
        })
        .catch(function () { lire(liste + 1, 1); });
    }

    lire(0, 1);
  }

  function veiller() {
    document.querySelectorAll('[data-vj-union]').forEach(remplir);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', veiller);
  } else {
    veiller();
  }
  document.addEventListener('shopify:section:load', veiller);
  if ('MutationObserver' in window) {
    var prevu = false;
    new MutationObserver(function () {
      if (prevu) return;
      prevu = true;
      window.requestAnimationFrame(function () { prevu = false; veiller(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
